import { useEffect, useState } from "react";
import { AlertOctagon, ExternalLink } from "lucide-react";
import { http } from "../../lib/api";

export const CreditBanner = () => {
  const [c, setC] = useState(null);
  useEffect(() => {
    const get = () => http.get("/ops/credits").then((r) => setC(r.data)).catch(() => {});
    get();
    const t = setInterval(get, 300000);
    return () => clearInterval(t);
  }, []);
  if (!c?.low) return null;
  return (
    <div data-testid="credit-banner" role="alert" className="mb-8 flex flex-wrap items-center gap-4 rounded-xl border border-red-200 bg-red-50 px-5 py-4 rise">
      <AlertOctagon size={22} className="text-red-700 shrink-0" />
      <div className="min-w-0 flex-1">
        <div className="font-display text-lg text-red-900">AI credit is too low to build</div>
        <div data-testid="credit-banner-text" className="text-sm text-red-800">
          Your OpenRouter balance is <b>{c.balance < 0 ? `-$${Math.abs(c.balance).toFixed(2)} (over budget)` : `$${Number(c.balance).toFixed(2)}`}</b>, below your ${c.floor.toFixed(0)} safety floor. New builds, checks and venue Replace are paused until you top up — finished work is kept.
        </div>
      </div>
      <a data-testid="credit-banner-topup" href="https://openrouter.ai/settings/credits" target="_blank" rel="noreferrer"
        className="inline-flex items-center gap-2 rounded-sm bg-red-700 px-4 py-2 text-sm font-bold text-white hover:bg-red-800 transition-colors">
        Top up credit <ExternalLink size={14} />
      </a>
    </div>
  );
};
